export default __webpack_public_path__ + "css/userEdit.bundle.css";